import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const faro = process.env.REACT_APP_FARO_URL
  ? initializeFaro({
      url: process.env.REACT_APP_FARO_URL,
      app: {
        name: 'orderly-frontend',
        version: process.env.REACT_APP_VERSION || 'latest',
        environment: process.env.NODE_ENV !== 'production' ? 'test' : 'prod',
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation({
          instrumentationOptions: {
            propagateTraceHeaderCorsUrls: [/\/graphql/],
          },
        }),
      ],
    })
  : undefined;

export default faro;
